import React from 'react'
import { Route } from 'react-router-dom'
import navigation from '../../config/navigation'
import CandidatesView from '../../views/CandidatesView/CandidatesView'
import HomeView from '../../views/HomeView/HomeView'
import LoginView from '../../views/LoginView/LoginView'
import ReportsView from '../../views/ReportsView/ReportsView'
import ScheduleView from '../../views/ScheduleView/ScheduleView'
import SettingsView from '../../views/SettingsView/SettingsView'
import WorklogView from '../../views/WorklogView/WorklogView'
import NotFoundView from '../../views/NotFoundView/NotFoundView'
import ProjectDetailsView from '../../views/ProjectDetailsView/ProjectDetailsView'
import UnauthorizedView from '../../views/UnauthorizedView/UnauthorizedView'
import UsersView from '../../views/UsersView/UsersView'
import ProfileView from '../../views/ProfileView/ProfileView'
import AdminsPageView from '../../views/AdminsPageView/AdminsPageView'
import TechStackView from '../../views/TechStackView/TechStackView'
import DictionarySettingsView from '../../views/TypographySettingsView/DictionarySettingsView'
import AccessibilitySettingsView from '../../views/AccessibilitySettingsView/AccessibilitySettingsView'
import GeneralSettingsView from '../../views/GeneralSettingsView/GeneralSettingsView'
import ProjectsDistributionView from '../../views/ProjectsDistributionView/ProjectsDistributionView'
import ProjectsView from '../../views/ProjectsView/ProjectsView'
import AddProjectView from '../../views/ProjectsView/AddProjectView'
import LandingPageView from '../../views/LandingPageView/LandingPageView'
import RouteGuard from './RouteGuard'
import LoadingUserDataView from '../../views/LoadingUserDataView/LoadingUserDataView'
import UserView from '../../views/UsersView/UserView'
import VacationView from '../../views/VacationView/VacationView'
import YearlySummaryView from '../../views/YearlySummary/YearlySummaryView'
import RoleType from '../../store/types/enums/RoleType'
import DemandsView from '../../views/DemandsView/DemandsView'
import AddDemand from '../../views/DemandsView/AddDemand'
import CandidateDetailsView from '../../views/CandidateDetailsView/CandidateDetailsView'
import CostSummaryView from '../../views/CostSummaryView/CostSummaryView'
import SettlementsView from '../../views/SettlementsView/SettlementsView'
import DynamicTitle from '../HelmetTitle/DynamicTitle'
import LeaderView from '../../views/LeaderView/LeaderView'
import AddContractView from '../../views/ContractsView/AddContractView'
import EditContractView from '../../views/ContractsView/EditContractView'

const routing = (
  <Route element={<DynamicTitle />}>
    <Route path={navigation.landing} element={<LandingPageView />} />
    <Route path={navigation.login} element={<LoginView />} />
    <Route path={navigation.unauthorized} element={<UnauthorizedView />} />
    <Route path={navigation.loading} element={<LoadingUserDataView />} />
    <Route
      element={
        <RouteGuard
          allowedRoles={[
            RoleType.BaseUser,
            RoleType.Employee,
            RoleType.Leader,
            RoleType.Management,
            RoleType.ProjectLeader,
            RoleType.Admin,
          ]}
        />
      }
    >
      <Route path={navigation.home} element={<HomeView />} />
      <Route path={navigation.myProfile} element={<ProfileView newUser={false} myProfile={true} />} />
    </Route>
    <Route
      element={
        <RouteGuard allowedRoles={[RoleType.Employee, RoleType.Leader, RoleType.Management, RoleType.ProjectLeader]} />
      }
    >
      <Route path={navigation.schedule} element={<ScheduleView />} />
      <Route path={navigation.usersSchedule} element={<ScheduleView />} />
      <Route path={navigation.worklog} element={<WorklogView />} />
      <Route path={navigation.usersWorklog} element={<WorklogView />} />
      <Route path={navigation.settings} element={<SettingsView />} />
      <Route path={navigation.vacation} element={<VacationView />} />
      <Route path={navigation.yearlySummary} element={<YearlySummaryView />} />
      <Route path={navigation.usersYearlySummary} element={<YearlySummaryView />} />
    </Route>
    <Route element={<RouteGuard allowedRoles={[RoleType.ProjectLeader, RoleType.Management]} />}>
      <Route path={navigation.demands} element={<DemandsView />} />
    </Route>
    <Route
      element={
        <RouteGuard allowedRoles={[RoleType.ProjectLeader, RoleType.Leader, RoleType.Management, RoleType.Admin]} />
      }
    >
      <Route path={navigation.projects} element={<ProjectsView />} />
      <Route path={navigation.projectDetails} element={<ProjectDetailsView />} />
      <Route path={navigation.userProfile} element={<ProfileView newUser={false} />} />
      <Route path={navigation.users} element={<UsersView />} />
      <Route path={navigation.user} element={<UserView />} />
      <Route path={navigation.addContract} element={<AddContractView />} />
      <Route path={navigation.editContract} element={<EditContractView />} />
      <Route path={navigation.leaderView} element={<LeaderView />} />
    </Route>
    <Route element={<RouteGuard allowedRoles={[RoleType.ProjectLeader, RoleType.Management, RoleType.Admin]} />}>
      <Route path={navigation.newProject} element={<AddProjectView />} />
    </Route>
    <Route element={<RouteGuard allowedRoles={[RoleType.Management, RoleType.ProjectLeader]} />}>
      <Route path={navigation.projectsDistribution} element={<ProjectsDistributionView />} />
      <Route path={navigation.addDemand} element={<AddDemand />} />
      <Route path={navigation.editDemand} element={<AddDemand />} />
    </Route>
    <Route element={<RouteGuard allowedRoles={[RoleType.Leader, RoleType.Management]} />}>
      <Route path={navigation.settlements} element={<SettlementsView />} />
    </Route>
    <Route
      element={
        <RouteGuard allowedRoles={[RoleType.Leader, RoleType.HR, RoleType.Management, RoleType.ProjectLeader]} />
      }
    >
      <Route path={navigation.reports} element={<ReportsView />} />
    </Route>
    <Route element={<RouteGuard allowedRoles={[RoleType.Management, RoleType.Recruiter]} />}>
      <Route path={navigation.candidates} element={<CandidatesView />} />
      <Route path={navigation.candidateDetails} element={<CandidateDetailsView newCandidate={false} />} />
      <Route path={navigation.newCandidate} element={<CandidateDetailsView newCandidate={true} />} />
    </Route>
    <Route element={<RouteGuard allowedRoles={[RoleType.Management, RoleType.Admin]} />}>
      <Route path={navigation.costSummary} element={<CostSummaryView />} />
      <Route path={navigation.newUser} element={<ProfileView newUser={true} />} />
      <Route path={navigation.adminPage} element={<AdminsPageView />} />
      <Route path={navigation.adminSettings} element={<AdminsPageView />}>
        <Route path={navigation.techStack} element={<TechStackView />} />
        <Route path={navigation.accessibility} element={<AccessibilitySettingsView />} />
        <Route path={navigation.general} element={<GeneralSettingsView />} />
        <Route path={navigation.dictionary} element={<DictionarySettingsView />} />
      </Route>
    </Route>
    <Route path={navigation.notFound} element={<NotFoundView />} />
  </Route>
)

export default routing
